import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const radioDefaultVariants = {
  "size": "md"
}
const radioCompoundVariants = [
  {
    "descriptionOrientation": "vertical",
    "css": {
      "root": {
        "rowGap": "{spacing.0}"
      }
    }
  },
  {
    "descriptionOrientation": "horizontal",
    "css": {
      "root": {
        "gap": "{spacing.8}"
      }
    }
  }
]

const radioSlotNames = [
  [
    "root",
    "radio__root"
  ],
  [
    "control",
    "radio__control"
  ],
  [
    "label",
    "radio__label"
  ],
  [
    "group",
    "radio__group"
  ],
  [
    "description",
    "radio__description"
  ],
  [
    "endIcon",
    "radio__endIcon"
  ]
]
const radioSlotFns = /* @__PURE__ */ radioSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, radioDefaultVariants, getSlotCompoundVariant(radioCompoundVariants, slotName))])

const radioFn = memo((props = {}) => {
  return Object.fromEntries(radioSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const radioVariantKeys = [
  "size",
  "descriptionOrientation"
]
const getVariantProps = (variants) => ({ ...radioDefaultVariants, ...compact(variants) })

export const radio = /* @__PURE__ */ Object.assign(radioFn, {
  __recipe__: false,
  __name__: 'radio',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: radioVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md"
  ],
  "descriptionOrientation": [
    "vertical",
    "horizontal"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, radioVariantKeys)
  },
  getVariantProps
})